import { DownloadBox } from 'components/shared/DownloadBox';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const pdfFiles = [
    <DownloadBox
        key="1"
        title="Executive Summary"
        description="One page company overview for general audiences."
        fileType="PDF"
        fileSize="569 kb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Executive-Summary.pdf"
    />,
    <DownloadBox
        key="2"
        title="Executive Summary for Payers"
        description="One page company overview for payer audiences."
        fileType="PDF"
        fileSize="546 kb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/Executive_Summary_Payer.pdf"
    />,
    <DownloadBox
        key="3"
        title="Infographic Summary for Payers"
        description="Electronic-only company overview for payer audiences."
        fileType="PDF"
        fileSize="725 kb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Overview-Info-Payer.pdf"
    />,
    <DownloadBox
        key="4"
        title="Payer Pitch"
        description="The latest company pitch for payers. Need the PowerPoint version? Reach out to the marketing team."
        fileType="PDF"
        fileSize="669 kb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Payer-Pitch.pdf"
    />,
];

const brandedFiles = [
    <DownloadBox
        key="5"
        title="LinkedIn Banner"
        description="NOTE: After opening the image right-click and save image to your computer."
        fileType="PNG"
        fileSize="141 kb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Employee-LinkedIn-Banner.png"
    />,
    <DownloadBox
        key="6"
        title="Teams Backgrounds"
        description="NOTE: After downloading the ZIP file, double click it to open."
        fileType="ZIP"
        fileSize="1.4 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Teams-Backgrounds.zip"
    />,
];

export const Files = () => (
    <div>
        <Page
            pageTitle="Files"
            pageDescription="This repository contains FMH branded files for a variety of uses."
            pageContent={
                <>
                    <Section title="PDF Files" contentArray={pdfFiles} />
                    <Section title="Branded Files" contentArray={brandedFiles} />
                </>
            }
        />
    </div>
);
